import {select} from 'd3-selection';

function filterRegions(callback, noFacet = false) {
  let regions = this.regions();
  if (!callback || typeof callback !== 'function') return regions;
  if (noFacet) {
    regions =  regions.filter(function() {
      return !select(this).classed('facet'); //facet region은 비포함
    })
  }
  return regions.filter(callback);
}

export default filterRegions;


// WEBPACK FOOTER //
// ./layouts/default/filterRegions.js